import { render, staticRenderFns } from "./StocksControlledTools.vue?vue&type=template&id=9cf505cc&scoped=true&"
import script from "./StocksControlledTools.vue?vue&type=script&lang=js&"
export * from "./StocksControlledTools.vue?vue&type=script&lang=js&"
import style0 from "./StocksControlledTools.vue?vue&type=style&index=0&id=9cf505cc&scoped=true&lang=css&"
import style1 from "./StocksControlledTools.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf505cc",
  null
  
)

export default component.exports
import {QItem,QItemSection,QField,QItemLabel,QBtnToggle,QCheckbox,QBtn,QSpace,QTr,QTh,QTd,QInnerLoading,QSpinnerGears,QTable,QBtnGroup} from 'quasar'
component.options.components = Object.assign({QItem,QItemSection,QField,QItemLabel,QBtnToggle,QCheckbox,QBtn,QSpace,QTr,QTh,QTd,QInnerLoading,QSpinnerGears,QTable,QBtnGroup}, component.options.components || {})
